<template>
  <div class="app-toolbar-content sm-line-height">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppToolbarContent',
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;
@use '@/styles/functions.scss' as *;

.app-toolbar-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  > * {
    margin-bottom: 0.5rem !important;
    margin-top: 0;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}

:deep(.app-toolbar) {
  &.column {
    .app-toolbar-content {
      align-items: start;
    }
  }
}
</style>
